/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

type ErrorLabelProps = {
  fieldErrors: any
  customError: any
  name: string
}

export const ErrorLabel: React.FC<ErrorLabelProps> = ({
  fieldErrors,
  customError,
  name,
}) => {
  const isArrayShape = Array.isArray(fieldErrors)

  const message =
    (customError && customError[name]) ||
    // Map-shaped fieldErrors ({ field: message }) — e.g. API field errors
    // (player/family forms) — carry the real per-field message, so show that
    // and never the generic copy. Only the legacy array shape (a list of
    // errored field names, no message) falls back to the static string.
    (isArrayShape ? 'This Field Is Mandatory' : fieldErrors?.[name])

  /*
   * Title Case belongs to OUR generic copy only.
   *
   * Keying it off the array shape alone mangled real API text: a form can use
   * the array shape for "which fields errored" while still putting the API's
   * sentence in `customError` (LocationModal does exactly this), which rendered
   * "The Address.Street 1 Field Is Required." Capitalize only when the string
   * shown is the static fallback we wrote.
   */
  const isGenericCopy = isArrayShape && !(customError && customError[name])

  return (
    <div
      tabIndex={-1}
      css={css`
        text-transform: ${isGenericCopy ? 'capitalize' : 'none'};
        transition: opacity 0.1s ease-in-out;
        display: ${fieldErrors[name] ||
        (Array.isArray(fieldErrors) && fieldErrors?.includes(name))
          ? 'inline'
          : 'none'};
        font-size: 13px;
        line-height: 16px;
        color: ${colors.ERROR_LIGHT};
      `}
    >
      <span>{message}</span>
    </div>
  )
}
